import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../../widgets/layout/CardUI'
import GenericErrorUI from '../../../common/GenericErrorUI'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import SpinnerComponentUI from '../../../common/SpinnerComponentUI'
import FileUploadModalSF from '../../../../widgets/form/FileUploadModalSF'
import AccountMappingCreateModalSF from './AccountMappingCreateModalSF'
import AccountMappingUpdateModalSF from './AccountMappingUpdateModalSF'
import './FileList.css'
import SpinnerUI from '../../../../widgets/output/SpinnerUI'

const FileListUI = ({ context, account, title, folder, accountFileList,
  fileSubmitted, onFileClick,
  fileDownloadMode, onFileDownloadClick,
  fileUploadMode, fileUploadSubmitted, fileUploadSuccessMsg, fileUploadErrorList,
  onFileUploadClick, onfileUploadCancel, onfileUpload,
  onFileDeleteClick, deleteFileMode, selectedFile
}) =>
  <CardUI title={title} className='c_fl_lst g_m_top_100'>
    <div className='g_flex_h g_flex_right'>
      <Link onClick={onFileUploadClick} to='#'>
        Upload
      </Link>
    </div>
    {
      accountFileList.filter(f => f.folder === folder).length > 0 &&
      <table className='fl_lst'><tbody>
        {
          accountFileList.filter(f => f.folder === folder).filter(f => f.size > 999).map((accountFile, i) =>
            <tr key={i}>
              <td className='name'>
                <span className='g_flex_h g_flex_left g_flex_top'>
                  <span className='g_m_right_50'>{i + 1}.</span>
                  <span className='g_flex_v'>
                    <Link onClick={onFileClick}
                      to='#' data-folder={accountFile.folder} data-file-name={accountFile.fileName}>
                      {accountFile.fileName}
                    </Link>
                    <span className='g_muted'>{accountFile.updatedByName}</span>
                  </span>
                </span>
              </td>
              <td className='g_text_right'>{accountFile.dateUpdatedF}</td>
              <td className='g_text_right'>{accountFile.sizeF}</td>
              <td className='g_text_right'><span className='icon-download g_cursor_pointer' onClick={onFileDownloadClick}
                data-folder={accountFile.folder} data-file-name={accountFile.fileName} />
              </td>
              <td className='g_text_right'>
                <span className='g_flex_h g_flex_right'>
                  <span className='icon icon-trash-o g_m_right_50' onClick={onFileDeleteClick}
                    data-folder={accountFile.folder} data-file-name={accountFile.fileName} />
                  <SpinnerUI show={selectedFile === accountFile.fileName && deleteFileMode} />
                </span>
              </td>
            </tr>
          )
        }
      </tbody></table>
    }

    {
      accountFileList.filter(f => f.folder === folder).length == 0 &&
      <div className='g_text_center g_m_top_100 g_m_bottom_100'>
        Zilch
      </div>
    }

    <FileUploadModalSF
      context={context}
      uploadMode={fileUploadMode}
      onCancelClick={onfileUploadCancel}
      signedUrlApi={`/api/su/accounts/${account.accountId}/files/fileUploadSignedUrl`}
      onUpload={onfileUpload}
      multiple={true}
    />
  </CardUI>

export default FileListUI
